import { axiosClient } from "services/axios";

import {
  AddProductGroupParams,
  EditProductGroupParams,
} from "../types";

export function getProductGroups() {
  return axiosClient.get("items/group").then((res) => res.data);
}

export function addProductGroup(params: AddProductGroupParams) {
  return axiosClient.post("items/group", params);
}

export function editProductGroup(params: EditProductGroupParams) {
  return axiosClient.put("items/group", params);
}

export function deleteProductGroup(groupId: string | number) {
  return axiosClient.post("items/delete-group", {
    group_id: Number(groupId),
  });
}
